import { withBasePath } from "@/lib/portal/base-path";

/** Router-relative path for the Request access doc page. */
export const GLOFOX_REQUEST_ACCESS_HREF = "/glofox/request-access";

/** Router-relative Redoc path (see `npm run build:glofox-api-docs`). */
export const GLOFOX_API_REFERENCE_HREF = "/glofox/api/openapi-reference.html";

/** Absolute path for plain anchors / window.location to the static Redoc HTML. */
export function getGlofoxApiReferenceHref(): string {
  return withBasePath(GLOFOX_API_REFERENCE_HREF);
}

const GLOFOX_AUTH_ROUTES = ["/login", "/glofox/sandbox"] as const;

export function resolveGlofoxTopNavActive(pathname: string | null): {
  docs: boolean;
  apiReference: boolean;
  requestAccess: boolean;
} {
  if (!pathname) {
    return { docs: false, apiReference: false, requestAccess: false };
  }

  if (
    pathname === "/glofox/api-reference" ||
    pathname === GLOFOX_API_REFERENCE_HREF
  ) {
    return { docs: false, apiReference: true, requestAccess: false };
  }

  if (pathname === GLOFOX_REQUEST_ACCESS_HREF) {
    return { docs: false, apiReference: false, requestAccess: true };
  }

  if (GLOFOX_AUTH_ROUTES.includes(pathname as (typeof GLOFOX_AUTH_ROUTES)[number])) {
    return { docs: false, apiReference: false, requestAccess: false };
  }

  if (pathname.startsWith("/glofox")) {
    return { docs: true, apiReference: false, requestAccess: false };
  }

  return { docs: false, apiReference: false, requestAccess: false };
}
